import request from '@/utils/request'

// 新增在线咨询管理
export function addZxzx(data) {
  return request({
    url: '/web/zxzx',
    method: 'post',
    data: data
  })
}

//
export function sendCode(tel) {
  return request({
    url: '/web/zxzx/' + tel,
    method: 'get'
  })
}

// 查询在线咨询管理列表
export function listZxzx(query) {
  return request({
    url: '/web/zxzx/list',
    method: 'get',
    params: query
  })
}

//查询在线咨询回复
export function listReply(query) {
  return request({
    url: '/web/zxzx/reply/list',
    method: 'get',
    params: query
  })
}

// 企业工作室调用-查询在线咨询管理列表
export function findAll(query) {
  return request({
    url: '/web/zxzx/findAll',
    method: 'get',
    params: query
  })
}

// 企业工作室调用-查询回复内容列表
export function findReplyAll(query) {
  return request({
    url: '/web/zxzx/findReplyAll',
    method: 'get',
    params: query
  })
}

// 企业工作室调用-咨询业务类型
export function findZxzxYw() {
  return request({
    url: '/web/zxzx/findZxzxYw',
    method: 'get',
  })
}
